import { api } from "../.."

// função para pesquisar centros de custo do gerente
const ManagersCostCentersService = async (description: string, page: number) => {

    const response = await api.get('managers/cost_centers', {
        params: {
            description, page
        }
    });

    return response;

}
// função para pesquisar centros de custo do gerente

// função para pesquisar dados de um centro de cusyto
const ManagersCostCentersShowService = async (id: number) => {

    const response = await api.get(`managers/cost_centers/${id}`);

    return response;

}
// função para pesquisar dados de um centro de cusyto

// função para pesquisar aprovadores
const ManagersCostCentersApproversService = async (id: number) => {

    const response = await api.get(`managers/cost_centers/approvers/${id}`);

    return response;

}
// função para pesquisar aprovadores

// função para adicionar um aprovador
const ManagersCostCentersCreateApproverService = async (id: number, user: number, level: number) => {

    const response = await api.post(`managers/cost_centers/approvers/${id}`, {
        user, level
    });

    return response;

}
// função para adicionar um aprovador

// função para ativar/desativar aprovador
const ManagersApproversDeleteService = async (costCenter: number, user: number, level: number) => {

    const response = await api.delete(`managers/cost_centers/approvers/${costCenter}/${user}`, {
        params: {
            level
        }
    });

    return response;

}
// função para ativar/desativar aprovador

// função para pesquisar todos os centros de custo
const ManagersAllCostCentersService = async () => {

    const response = await api.get('managers/cost_centers/all');

    return response;

}
// função para pesquisar todos os centros de custo

// função para adicionar nível de centro de custo
const MnaagersCostCentersAddLevelService = async (id: number) => {

    const response = await api.get(`managers/cost_centers/add_level/${id}`);

    return response;

}
// função para adicionar nível de centro de custo

const ManagersCostCentersEmployeesNotRegisteredService = async (id: number) => {

    const response = await api.get(`managers/cost_centers/empoloyees/not_registered/${id}`);

    return response;

}

const ManagersCostCenterAddEmployeeService = async (id: number, employees: string) => {

    const response = await api.post(`managers/cost_centers/employees/${id}`, {
        employees
    });

    return response;

}

const ManagersCostCenterRemoveEmployeeService = async (costCenter: number, user: number) => {

    const response = await api.delete(`managers/cost_centers/employees/${costCenter}/${user}`);

    return response;

}

// função para remover nível de centro de custo
const MnaagersCostCentersRemoveLevelService = async (id: number) => {

    const response = await api.get(`managers/cost_centers/remove_level/${id}`);

    return response;

}
// função para remover nível de centro de custo

export {
    ManagersCostCentersService,
    ManagersCostCentersShowService,
    ManagersCostCentersApproversService,
    ManagersCostCentersCreateApproverService,
    ManagersApproversDeleteService,
    ManagersAllCostCentersService,
    MnaagersCostCentersAddLevelService,
    ManagersCostCentersEmployeesNotRegisteredService,
    ManagersCostCenterAddEmployeeService,
    ManagersCostCenterRemoveEmployeeService,
    MnaagersCostCentersRemoveLevelService
}